import React from 'react';
import { MapPin, CheckCircle, Sparkles, UserCheck, ShieldCheck, Radio } from 'lucide-react';

const About = ({ onOpenContact }) => {
  return (
    <section id="about" className="section-padding" style={{ position: 'relative', background: '#f8fafc' }}>
      <div className="container">
        <div className="grid-2" style={{ gap: '3.5rem', alignItems: 'center' }}>
          {/* Left Column: Visual Showcase Frame */}
          <div style={{ position: 'relative' }}>
            <div
              className="glass-card"
              style={{
                padding: '0.75rem',
                borderRadius: '24px',
                background: '#ffffff',
                border: '1px solid #cbd5e1',
                boxShadow: '0 20px 40px -10px rgba(15, 23, 42, 0.1)',
                position: 'relative',
                overflow: 'hidden',
              }}
            >
              <div style={{ position: 'relative', borderRadius: '18px', overflow: 'hidden', height: '400px' }}>
                <img
                  src="/foif_a90_park.jpg"
                  alt="Real Field Operation - DGPS High-Accuracy Survey Work"
                  style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                />
                <div
                  style={{
                    position: 'absolute',
                    inset: 0,
                    background: 'linear-gradient(to top, rgba(15, 23, 42, 0.75) 0%, transparent 55%)',
                  }}
                />
                <div style={{ position: 'absolute', bottom: '1.25rem', left: '1.25rem', right: '1.25rem', color: '#ffffff' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                    <div className="pulse-dot" />
                    <span style={{ fontSize: '0.8rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#38bdf8' }}>
                      Real Field Operation
                    </span>
                  </div>
                  <h3 style={{ fontSize: '1.25rem', color: '#ffffff', fontWeight: '800', marginBottom: '0.25rem' }}>
                    DGPS High-Accuracy Survey Work On Site
                  </h3>
                  <p style={{ color: '#cbd5e1', fontSize: '0.85rem' }}>
                    Theni & Tamil Nadu Regional Projects
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column: Why Choose Us */}
          <div>
            <div className="section-subtitle">Why Choose B Digital Land Survey</div>
            <h2 className="section-title" style={{ textAlign: 'left', marginBottom: '1.25rem', color: '#0f172a', lineHeight: 1.25 }}>
              Uncompromising Accuracy & <span className="gradient-text">Professional Consulting</span>
            </h2>

            <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: 1.7, marginBottom: '2rem' }}>
              We deliver complete peace of mind by combining modern satellite DGPS hardware with digital CAD drafting to make your land dreams a reality.
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
              {[
                { title: 'High Accuracy Land Survey by Using DGPS', desc: 'Satellite RTK dual-frequency positioning ensuring exact land boundary coordinates in WGS84 & UTM format.' },
                { title: 'Bridge and Road Alignment Preparation', desc: 'We provide accurate bridge and road alignment planning based on detailed site surveys.' },
                { title: 'W.R.D. Water Resources Development', desc: 'Specialized canal L-sections, river bed profiling, water body contours, and tank bund surveying.' },
                { title: '100 MW Solar Power Project Experience', desc: 'Vel Engineering Service, Karur: land purchasing survey & pile marking for a ~100 MW solar power project near Trichy.' },
                { title: 'Fast Digital CAD & Drafting', desc: 'Clean layered DWG/DXF drawings and plot-ready PDF sheets returned within 24-48 hours post fieldwork.' },
                { title: 'Direct Surveyor Availability', desc: 'Dedicated field support based in Theni, serving clients across Tamil Nadu.' }
              ].map((item, idx) => (
                <div key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
                  <div
                    style={{
                      width: '32px',
                      height: '32px',
                      borderRadius: '50%',
                      background: '#fff5f5',
                      border: '1px solid #fed7d7',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#e63946',
                      flexShrink: 0,
                      marginTop: '0.2rem',
                    }}
                  >
                    <CheckCircle size={18} />
                  </div>
                  <div>
                    <h4 style={{ fontSize: '1.1rem', color: '#0f172a', marginBottom: '0.25rem' }}>{item.title}</h4>
                    <p style={{ color: '#475569', fontSize: '0.925rem', lineHeight: 1.6 }}>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div style={{ marginTop: '2rem' }}>
              <button onClick={() => onOpenContact()} className="btn-primary btn-glow">
                Contact Surveyor Directly <Radio size={16} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
